import {
    takeEvery,
    takeLatest,
    put
} from 'redux-saga/effects';

import api from 'services/restApiHelper';
import DodService from 'services/DodService';
const baseUrl = process.env.REACT_APP_BASE_URL;

//tell eslint that Promise is a global var
/*global Promise */

export function* fetchDodsFlow(action) {
    try {
        // dods are only pushed to local storage when opening a new window, so we don't have to re-load
        const dodsById = localStorage.getItem('dodsById');
        const prodDods = localStorage.getItem('prodDods');

        if (dodsById && prodDods) {
            localStorage.removeItem('dodsById');
            localStorage.removeItem('prodDods');
            const response = {
                dodsById: JSON.parse(dodsById),
                prodDods: JSON.parse(prodDods)
            };

            yield put({
                type: DodService.DODS_FETCH_SUCCESS,
                response
            });

        } else {
            const response = yield api.get(`${baseUrl}/processdods`);
            yield put({
                type: DodService.DODS_FETCH_SUCCESS,
                response
            });
        }
    } catch (error) {
        yield put({
            type: DodService.DODS_FETCH_ERROR,
            error
        });
    }
}

export function* fetchDodVarsFlow(action) {
    try {
        const response = yield api.get(`${baseUrl}/dods/${action.dod}/variables?process=true`);
        yield put({
            type: DodService.DOD_VARS_FETCH_SUCCESS,
            response,
            dod: action.dod
        });
    } catch (error) {
        yield put({
            type: DodService.DOD_VARS_FETCH_ERROR,
            error
        });
    }
}

export function* watchDodRequests() {
    yield takeEvery(DodService.DODS_FETCH_START, fetchDodsFlow);
    yield takeLatest(DodService.DOD_VARS_FETCH_START, fetchDodVarsFlow);
}



// WEBPACK FOOTER //
// ./src/services/sagas/DodServiceSagas.js